{
  "rest400": "Validation Error",
  "image.delete": "Could not delete the image. Please try again.",
  "accountSettings.contactInformation.updateError": "Could not save contact information. Please try again.",
  "associate.delete": "Could not delete associate. Please try again.",
  "associate.edit": "Could not edit assoicates. Please try again.",
  "attachmentResponseError": "Could not find attachment file. Try going back to the page.",
  "attachmentFilesLoadFailed": "Could not load all attachments.",
  "brreg.error": "Could not fetch data from BrReg. Please try again.",
  "brreg.notFound": "Not found in Brønnøysundsregistrene.",
  "city.notFound": "City not found.",
  "clusterAdvisor.create": "Could not add as advisor. Please try again.",
  "clusterAdvisor.remove": "Could not remove advisors. Please try again.",
  "clusterBoardMember.create": "Could not add board member. Please try again.",
  "clusterBoardMember.remove": "Could not remove contacts from board. Please try again.",
  "clusterManagement.create": "Could not add to management. Please try again.",
  "clusterMissingManager": "Cluster is missing a cluster manager",
  "clusterVisionMision.update": "Could not update clusters vision and mission. Please try again.",
  "company.infoNotFound": "Could not find information about company. Please try again.",
  "companyCreate": "Could not create new company. Please try again.",
  "companyInformation.update": "Could not update company information. Please try again.",
  "companyUpdate": "Could not update company. Please try again.",
  "contact.add.interestArea": "Could not update interest area for contact.",
  "contact.couldNotCreate": "Could not create contact. Please try again.",
  "contact.edit": "Could not update contact. Please try again.",
  "contact.remove.interestArea": "Could not remove interest area for contact.",
  "contact.update.information": "Could not update contactinformation.",
  "contacts.delete": "Could not delete contacts. Please try again.",
  "contacts.edit": "Could not edit contacts. Please try again.",
  "couldNotCreateGeneric": "Could not create {{ value }}. Please try again.",
  "email.alreadyInUseInList": "This email is already used by another contact in this form.",
  "entityNotFound": "{{ entityName }} not found.",
  "error.EditEventWithTimeEntries": "Event date cannot be changed after time entries have been registered on the event.",
  "error.FetchingData": "An error occurred while fetching data. Please try again.",
  "errorButSaved": "An error has occured, but the data has been saved.",
  "errorCode.BothReqularAndCustom": "Both regular financing source and custom cannot be used simultaneously",
  "errorCode.EndDateBeforeStartDate": "End date cannot be before start date",
  "errorCode.FileTypeNotSupported": "Filetype not supported",
  "errorCode.GreaterThanOrEqualToZero": "{{fieldName}} must be greater than or equal to zero",
  "errorCode.GreaterThanZero": "{{fieldName}} must be greater than zero",
  "errorCode.InvalidOrganizationNumber": "Invalid organization number",
  "errorCode.MissingFinanceSource": "Financing source and custom name cannot both be null",
  "errorCode.NotFound": "{{fieldName}} was not found",
  "errorCode.Required": "{{fieldName}} is required",
  "excel.import.error": "Something went wrong during the importation of the Excel-file. There may be a difference between your file and the template. Download the template and please try again.",
  "excel.validation.title": "Errors occurred in the Excel-schema",
  "fieldCannotBeBlank": "This field cannot be empty.",
  "focusArea.create": "Could not create focus area. Please try again.",
  "focusArea.update": "Could not update focus area. Please try again.",
  "frontend.ErrorBoundaryTitle": "An error has occurred, contact us and refer to the id shown on the page",
  "generic.create": "Something went wrong with the creationg. Please try again.",
  "leads.delete": "Could not delete leads. Please try again.",
  "leads.edit": "Could not edit leads. Please try again.",
  "leadsNotApproved": "Could not approve leads to members. Try again.",
  "least1RowForAction": "You have to mark atleast 1 row to perform this action.",
  "mainGoal.create": "Could not create main goal. Please try again.",
  "mainGoal.update": "Could not update main goal. Please try again.",
  "member.addContacts": "Could not add all contacts. Please try again.",
  "member.couldNotCreate": "Could not create member. Please try again.",
  "member.create.plural": "Something went wrong under creation of members. Please try again.",
  "member.massDelete": "Could not delete all members. Please try again.",
  "member.massUpdate": "Could not update all members. Please try again.",
  "member.removeContacts": "Could not remove all contacts from member. Please try again.",
  "member.removeInterestArea": "Could not remove interest area from member. Please try again.",
  "member.update": "Could not update member. Please try again.",
  "member.update.mainContact": "Could not update main contact for member. Please try again.",
  "member.updateInterestArea": "Could not update interest areas for member. Please try again.",
  "memberFee.create": "Could not create memberfee. Please try again.",
  "memberFee.delete": "Could not delete memberfee. Please try again",
  "memberFee.update": "Could not update memberfee. Please try again",
  "noClusterChosen": "No cluster is chosen. Please choose a cluster before this action can be performed.",
  "noClusterMemberId": "No member id found. Try going back to the page.",
  "noFileSelected": "Could not find file. Try selecting it anew.",
  "onewayinLeadNoCreateDto": "Could not create lead. Try to close and open the modal again.",
  "only1RowToChangeRole": "You can only change one persons role at a time.",
  "organizationNumber.alreadyInUse": "Organization number already in use.",
  "organizationNumberAlreadyInUse": "Organization number already in use.",
  "portalInvitation.send": "Could not send portal invitations. Please try again.",
  "postCode.notFound": "City not found for this postal code.",
  "projectCategory.create": "Could not create project category. Check if the name is already used, and please try again.",
  "requiresOneFile": "At least one file must be attached",
  "rest404": "Could not find {{ entityName }}",
  "rest409": "Your changes might be conflicting with other people's changes. Try again.",
  "rest500": "A critical error has occured. Administrators have been notified.",
  "roles.update": "Could not update roles for {{ name }}. Please try again.",
  "selfEffort.couldNotImport": "Could not upload in kind. Check that the spreadsheet follows the template.",
  "selfEffort.couldNotRegister": "Could not edit in kind. Check that the spreadsheet follows the template.",
  "selfEffort.newContactInvalidEmail": "Could not create new contact with invalid email {{ email }}.",
  "selfEffort.newContactNoEmail": "Could not create new contact with empty email {{ email }}.",
  "selfEffort.newContactsCreateError": "Could not create contacts. Check that you are following the spreadsheet-template and try again.",
  "selfEffort.newMemberCouldnotCreate": "Could not create member with organization number {{ orgNumber }}.",
  "selfEffort.newMemberCouldNotSave": "Could not save and fetch newest member('{{ member }}')",
  "selfEffortNotApproved": "Could not approve in kind.Please try again.",
  "somethingWentWrongTryAgain": "Something went wrong. Try again.",
  "tooBigFile": "Filesize is too big.",
  "undefinedProperty": "\"{{ property }}\" cannot be undefined.",
  "unretire.contact": "Could not unretire contact. Please try again.",
  "unretire.member": "Could not unretire member. Please try again.",
  "user.UserHasMultipleClusters": "User has multiple clusters, cluster id must be specified",
  "validation.email": "Not a valid email address.",
  "validation.maxValue": "The value cannot be larger than {{ value }}",
  "validation.minValue": "The value cannot be less than {{ value }}",
  "validation.missingFileName": "Missing filename",
  "validation.organizationNumber": "Not a valid organization number.",
  "validation.postalCode": "Not a valid postal code.",
  "validation.required": "This field is required.",
  "validation.uniqueEmailInClusterContacts": "This email is already in use by another contact in this cluster.",
  "wrongFileFormat": "Wrong file format.",
  "notFound.title": "Oops, there's nothing here",
  "notFound.subtitle1": "404: The page you tried to access was not found",
  "notFound.subtitle2": "It's possible that what you're looking for no longer exists, or you have logged in under a different actor. Feel free to check if you have logged in under the correct actor.",
  "noClusterUserId": "No user ID found, please try again.",
  "noOnboardingPacketId": "No onboarding packet ID could be found, try again.",
  "malwareDetected": "The file contains potentially harmful content and has been blocked. You can try uploading a different file."
}
